module.exports = __webpack_public_path__ + "static/img/9.1c3455b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/6/1/sp/9.png
// module id = VbmL
// module chunks = 0